import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import { CommonDataForSettingsService } from '@core/services/common-data-for-settings.service';
import { CategoriesDataService } from '@community-settings/core/services/categories-data.service';
import { map } from 'rxjs/operators';
import { Category } from '@sb-tools/typescript/models/category.model';

@Injectable()
export class CategoriesResolver implements Resolve<Category[]> {
    constructor(
        private categoriesDataService: CategoriesDataService,
        private commonDataForSettingsService: CommonDataForSettingsService,
    ) {}

    resolve(): Observable<Category[]> {
        return this.categoriesDataService.getAll().pipe(
            map((categories: Category[]) => {
                this.commonDataForSettingsService.categories = categories;
                return categories;
            }),
        );
    }
}
